import React, { useState } from 'react';
import { Check, Copy, ArrowUpRight, Feather } from 'lucide-react';
import './coverage.css';

export function CoverageBrand() {
  return (
    <span className="cvg-brand">
      <Feather size={23} aria-hidden="true" />{' '}
      <b>
        rx<span>rooster</span>
      </b>
      <span className="cvg-brand-label">PARTNER CONNECTIONS</span>
    </span>
  );
}
export function CoverageShell({
  children,
  aside,
  label = 'PARTNER CONNECTIONS',
  title,
  description,
  actions,
}) {
  return (
    <main className="cvg">
      <header className="cvg-top">
        <CoverageBrand />
        <a href="https://rxrooster.com" target="_blank" rel="noreferrer">
          About RxRooster <ArrowUpRight size={14} />
        </a>
      </header>
      <div className="cvg-body">
        <div className="cvg-heading">
          <div>
            <span className="cvg-eyebrow">{label}</span>
            <h1>{title}</h1>
            <p>{description}</p>
          </div>
          {actions}
        </div>
        <div className={aside ? 'cvg-layout' : ''}>
          <div>{children}</div>
          {aside && <aside>{aside}</aside>}
        </div>
      </div>
    </main>
  );
}
export function CopyButton({ text, children = 'Copy', secondary = true }) {
  const [state, setState] = useState('');
  return (
    <>
      <button
        type="button"
        className={secondary ? 'cvg-button cvg-secondary' : 'cvg-button'}
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(text);
            setState('Copied');
          } catch {
            setState('Select and copy the text below.');
          }
        }}
      >
        {state === 'Copied' ? <Check size={15} /> : <Copy size={15} />}
        {state === 'Copied' ? 'Copied' : children}
      </button>
      {state && state !== 'Copied' && <span role="status">{state}</span>}
    </>
  );
}
export function ErrorMessage({ children }) {
  const message = (value) => {
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map(message).join(' ');
    if (value && typeof value === 'object' && value.message !== value)
      return message(value.message);
    return 'Something went wrong. Please try again.';
  };
  return children ? (
    <div role="alert" className="cvg-error">
      {message(children)}
    </div>
  ) : null;
}
export function CodeBlock({ code, label }) {
  return (
    <div className="cvg-code">
      <div>
        <span>{label}</span>
        <CopyButton text={code} />
      </div>
      <pre>
        <code>{code}</code>
      </pre>
    </div>
  );
}
